import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  
  @Input()
  public openModalClearAll;
  @Output()
  public isOpenModalClearAll = new EventEmitter<any>();

  public customHeader = true
  public modalTitle = 'modal title';

  handleOpenClose = (event: any) => {
    this.isOpenModalClearAll.emit(event);
  }
  applyModal = () => {
    this.isOpenModalClearAll.emit({status: false, value: 'apply'});
  }
}
